import { t } from '@lingui/core/macro'
import { useMemo, useState } from 'react'
import ECharts from '~/components/echarts'
import Filters from '~/dashboard/azure_database_dashboard_filters'
import { azureDbMonthlyCostsByMeterSubCategoryQueryChartPath } from '~/routes'

export default function AzureVirtualMachinesDashboardCharts({ organizationId: orgId }) {
  const [params, setParams] = useState({ azureCostKind: 'ActualCost' })

  const monthlyCostsByMeterSubCategoryUrl = useMemo(
    () => azureDbMonthlyCostsByMeterSubCategoryQueryChartPath(orgId),
    [orgId],
  )

  return (
    <div className='card'>
      <div className='card-body'>
        <Filters organizationId={orgId} setChartParams={setParams} />
        <div className='row g-0'>
          <div className='col-sm-6'>
            <ECharts
              title={t`Monthly Database Costs By Meter SubCategory`}
              chartInfoTitle='azure_db_monthly_costs_by_meter_subcategory'
              url={monthlyCostsByMeterSubCategoryUrl}
              params={params}
              showExportButton
            />
          </div>
        </div>
      </div>
    </div>
  )
}
